var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterDrop250DpEff5F2Fill0Wght200Grad0Opsz48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#EFF5F2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M482.85-215.69q10.61-.77 16.03-4.46 5.43-3.7 5.43-11.04 0-6.73-5.64-10.04-5.64-3.31-16.05-3.31-41.24 1.54-90.89-27.27t-61.65-95.81q-1.23-9-5.48-12.96-4.24-3.96-9.81-3.96-6.64 0-10.71 5.04-4.08 5.04-2.85 14.04 15 80.92 73.31 115.73t108.31 34.04ZM479.86-120q-119.94 0-199.9-82.54Q200-285.07 200-408q0-86.15 69.5-190.58Q339-703 480-827.69 621-703 690.5-598.58 760-494.15 760-408q0 122.93-80.1 205.46Q599.79-120 479.86-120Zm.18-30.77q107.34 0 178.27-73.46 70.92-73.46 70.92-183.84 0-75.85-63.42-171.74Q602.38-675.69 480-786.15 357.62-675.69 294.19-579.81q-63.42 95.89-63.42 171.74 0 110.38 70.96 183.84 70.96 73.46 178.31 73.46ZM480-473.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterDrop250DpEff5F2Fill0Wght200Grad0Opsz48);
export default __webpack_public_path__ + "static/media/water_drop_250dp_EFF5F2_FILL0_wght200_GRAD0_opsz48.72c747669cb1b64727bfa92ba9bac97f.svg";
export { ForwardRef as ReactComponent };